import React, { useState, useEffect, useContext } from "react";
import { TableContainer, IconButton, Button, Stack, Tooltip, Box, Divider } from "@mui/material";
import { withStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import { withSnackbar } from "notistack";
import performRequest from "network/perform-request";
import { classificationEventSystemsIndexRoute } from "network/api-routes";
import { ROUTES } from "constants/routes";
import { Link } from "react-router-dom";
import RevaText from "components/common/RevaText";
import Loading from "components/common/Loading";
import UserContext from "context/UserContext";

const styles = (theme) => ({
  createButton: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  sectionTitleContainer: {
    justifyContent: "space-between",
    alignItems: "center",
  },
});

const ClassificationEventsIndex = ({ classes, userContext, enqueueSnackbar, history }) => {
  //a component that shows a list of event systems of classifications. Retrieves from server and shows them.
  const { user, selectedOrganization } = useContext(UserContext);
  const [ready, setReady] = useState(false);
  const [eventSystemsList, setEventSystemsList] = useState(null);

  //on mount, fetch the list of tournaments
  useEffect(() => {
    performRequest(
      "POST",
      classificationEventSystemsIndexRoute,
      { organization_id: selectedOrganization?.id || null },
      true,
      user
    )
      .then((response) => {
        if (response.data) {
          setEventSystemsList(response.data);
          setReady(true);
        }
      })
      .catch((error) => {
        console.log(error);
        enqueueSnackbar(error.message, { variant: "error" });
        setReady(true);
      });
  }, [enqueueSnackbar, user, selectedOrganization]);

  if (!ready) return <Loading />;

  const getEventTitle = (type) => {
    switch (type) {
      case "suggestPromotion":
        return "Ascenso";
      case "descentOfClassification":
        return "Descenso";
      default:
        return "?";
    }
  };
  return (
    <Stack>
      <Stack direction="row" className={classes.sectionTitleContainer}>
        <RevaText variant="h4">{`Eventos de rankings ${userContext.selectedOrganization?.name}`}</RevaText>
        <Button
          component={Link}
          to={`${ROUTES.ADMIN.ORGANIZATIONS}/classification-events/create`}
          className={`cta ${classes.createButton}`}
        >
          Crear evento
        </Button>
      </Stack>
      <Divider sx={{ my: 2 }} />
      <TableContainer sx={{ borderRadius: 2 }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "grey.900" }}>
              <TableCell sx={{ fontWeight: 600 }}>Organización</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Ranking</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Evento</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Condiciones</TableCell>
              <TableCell align="center" sx={{ fontWeight: 600 }}>
                Acciones
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {eventSystemsList.map((eventSystem, index) => {
              const eventType = Object.keys(eventSystem.eval_conditions)[0];
              const eventConditions = Object.values(eventSystem.eval_conditions)[0];
              const eventTitle = getEventTitle(eventType);
              return (
                <TableRow
                  key={eventSystem.id}
                  hover
                  sx={{
                    backgroundColor: "background.paper",
                    "&:last-child td": { borderBottom: 0 },
                  }}
                >
                  <TableCell>{eventSystem.organization_name}</TableCell>
                  <TableCell>{eventSystem.classification_name}</TableCell>
                  <TableCell>{eventTitle}</TableCell>
                  <TableCell>
                    <Box display="flex" flexDirection="column" gap={0.5}>
                      {eventConditions.total_participations && (
                        <div>Total de participaciones: {eventConditions.total_participations}</div>
                      )}
                      {eventConditions.was_champion && (
                        <div>Total de torneos ganados: {eventConditions.was_champion}</div>
                      )}
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    <Tooltip title="Editar">
                      <IconButton
                        size="small"
                        onClick={() =>
                          history.push({
                            pathname: `${ROUTES.ADMIN.ORGANIZATIONS}/classification-events/${eventSystem.uuid_}/edit`,
                            state: { eventSystem },
                          })
                        }
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Eliminar">
                      <IconButton size="small" onClick={() => {}}>
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
};

export default withSnackbar(withStyles(styles)(ClassificationEventsIndex));
